export const API_URL = process.env.REACT_APP_API_URL;

export const endpoints = {
  guestAuthLoginChallenge: `${API_URL}/guest/auth/login/challenge`,
  guestAuthRefresh: `${API_URL}/guest/auth/refresh`,
  guestAuthLogin: `${API_URL}/guest/auth/login`,
};

export const paths = {
  guest: "guest",
  auth: "auth",
  login: "login",
  challenge: "challenge",
  refresh: "refresh",
  reservations: "reservations",
  addMissing: "add-missing",
  openReservation: "open_reservation",
  iot: "iot",
  doors: "doors",
  properties: "properties",
  units: "units",
  availability: "availability",
  rentalsGuardianProducts: "rentals-guardian-products",
  book: "book",
  payWith: "pay-with",
  stripe: "stripe",
  startSession: "start-session",
  lynnbrook: "lynnbrook",
  authorizeNet: "authorize-net",
  guidebooks: "guidebooks",
  guidebook: "guidebook",
  share: "share",
  propertyCustomFields: "property-custom-fields",
};
